<template>
  <div :class="classes">
    <div class="inner">
      <Paragraph :content="paragraphContent"></Paragraph>
      <a href="#link">
        <BasicButton
          v-if="buttonContent !== ''"
          :label="buttonContent"
          theme="light"
          button-type="tonal"
        />
      </a>
    </div>
  </div>
</template>

<script setup lang="ts">
import './PromoLine.scss';
import { computed } from 'vue';
import Paragraph from 'ewi-ui/components/1-atoms/Paragraph';
import BasicButton from 'ewi-ui/components/1-atoms/BasicButton/BasicButton.vue';

defineOptions({
  name: 'PromoLine',
});

export interface PromoLineProps {
  paragraphContent?: string;
  buttonContent?: string;
}

withDefaults(defineProps<PromoLineProps>(), {
  paragraphContent: '',
  buttonContent: '',
});

const classes = computed(() => ({
  'm-promo-line': true,
}));
</script>
